module.exports = __webpack_public_path__ + "static/github-icon.3eb2edd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/github-icon.png
// module id = 146
// module chunks = 27180705640166 213534597649335